<script>
    export default {
        inserted: function (el) {
            let popups = el.querySelectorAll('.popup');
            let playButtons = el.querySelectorAll('.play');

            let reset = function () {
                for (let popup of popups) {
                    popup.classList.remove('active');
                }
            }

            let stopVideos = function () {
                let iframes = el.querySelectorAll('iframe');
                if (iframes.length > 0) {
                    for(let iframe of iframes) {
                        let iframeSrc = iframe.src;
                        iframe.src = iframeSrc;
                    }
                }
            };

            let setOnClick = function (element, index) {
                element.onclick = function (e) {
                    e.preventDefault();
                    reset();
                    for (let i = 0; i < popups.length; i++) {
                        if (i === index) {
                            popups[index].classList.add('active');
                        }
                    }
                }
            }
            let setOnClickPopups = function (element) {
                element.onclick = function (e) {
                    e.preventDefault();
                    stopVideos();
                    reset();
                }
            }

            for (let i = 0; i < playButtons.length; i++) {
                setOnClick(playButtons[i], i);
                setOnClickPopups(popups[i]);
            }
        }
    }

</script>
